import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const HeroSectionLayout = ({
  pageType, children
}) => {
  return (
    <div className={
        clsx('relative px-7 py-14 pt-16 md:py-12 md:px-16 lg:px-[88px] xl:px-44 2xl:px-60', 
        pageType == 'lead' ? '' : 'lg:pb-[204px]')
      }>
      <div className={
        clsx('flex flex-col gap-11 lg:gap-28 justify-between items-center max-w-8xl mx-auto text-center lg:text-left',
        pageType == 'lead' ? '' : 'lg:flex-row')}
      >
        {children}
      </div>
    </div>
  );
};

HeroSectionLayout.propTypes = {
  pageType: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node)
};

export default HeroSectionLayout;
